<template>
  <div class="comment-create-form-component">
    <VTextarea
      v-model="commentForm"
      layout="vertical"
      label="Добавление комментария"
      @keydown.ctrl.enter="postComment"
    />

    <div class="actions">
      <VButton
        theme="primary"
        @click="postComment"
      >
        Добавить
      </VButton>
      <div class="description">
        Ctrl + Enter
      </div>
    </div>
  </div>
</template>

<style lang="scss" src="./VCommentCreateForm.scss"/>

<script lang="ts">
import Comment         from "@/core/services/Comments/Comment";
import CommentsService from "@/core/services/Comments/CommentsService";
import EntityPointer   from "@/domains/EntityPointer/EntityPointer";

export default {
	name: 'VCommentCreateForm',

	props: {
		/** Указатель на сущность, к которой добавляется комментарий. */
		parentEntity: {
			type:     EntityPointer,
			required: true,
		},
	},

	emits: [Comment.Events.Created],

	data() {
		return {
			commentForm: null,
			isLoading: false,
		};
	},

	methods: {
		async postComment() {
			if (!this.$core.utils.string.isNotEmptyString(this.commentForm)) return;
			if (this.isLoading) return;

			this.isLoading = true;

			try {
				const comment = Comment.fromNew(this.parentEntity, this.commentForm);
				const savedComment = await CommentsService.add(comment);

				if (savedComment) {
					this.commentForm = null;
					this.$emit(Comment.Events.Created, savedComment);
				}
			}
			finally {
				this.isLoading = false;
			}
		},
	},
};
</script>
